import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  pointer: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(128, 128, 128, 0.1) !important',
      boxShadow: '0 4px 8px rgba(128, 128, 128, 0.3)',
    },
  },
  tableRow: { height: '53px' },
  totalHrsTableCell: { paddingLeft: theme.spacing(9) },
  spentHrsTableCell: { paddingLeft: theme.spacing(7) },
  typographyVariant2: {
    marginLeft: '103%',
    color: 'black',
    marginTop: '-7px',
  },
  tableRowColor: {
    cursor: 'pointer',
    backgroundColor: 'rgba(255, 0, 0, 0.3) !important',
    '&:hover': {
      backgroundColor: 'rgba(255, 0, 0, 0.4) !important',
      boxShadow: '0 4px 8px rgba(255, 0, 0, 0.3)',
    },
  },
  tabsBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  filterContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: theme.spacing(1.5),
    backgroundColor: theme.palette.background.paper,
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
    width: 'fit-content',
    gap: theme.spacing(2),
  },
  progressText: {
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
  progressIcon: {
    height: '25px',
    opacity: '0.8',
    // filter: 'grayscale(0.3)',
  },
  inputContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    maxWidth: '300px',
    flex: 1,
  },
  textField: {
    width: '110px',
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: theme.palette.primary.main,
      },
    },
  },
  clearButton: {
    color: theme.palette.text.secondary,
    '&:hover': {
      color: theme.palette.error.main,
      backgroundColor: theme.palette.error.lighter,
    },
  },
  startAdornment: {
    color: theme.palette.dark.main,
  },
  endAdornment: {
    color: theme.palette.dark.main,
  },
}));
